import { css } from '@microsoft/fast-element';

export const SideMenuStyles = css`
  .side-menu {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 48px;
    top: 60px;
    right: 0;
    height: 100%;
    border-left: 1px solid var(--border-1);
    border-top: 1px solid var(--neutral-layer-1);
    background-color: var(--side-menu-bg);
    box-sizing: border-box;
    padding-top: 10px;
  }
`;
